<template>
    <v-row align="center" class="row--small font-size-14">
        <v-col cols="12" md="2">
            상품 옵션
        </v-col>
        <v-col cols="12" md="10">
            <template v-for="depth, index in optionalMaxDepth">
                <v-select v-model.lazy="selected[index]" :key="index" :label="optionalNames[index]" :items="items(depth)"  persistent-placeholder outlined dense hide-details item-disabled="stock" class="mt-2" @input="input(depth)" />
            </template>
        </v-col>
    </v-row>
</template>
<script>
export default {
    props: {
        value: { type: Array, default(){ return []; } },
        product: { type: Object },
    },
    data(){
        return {
            carts: this.$props.value || [],

            selected: []
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init(){
            this.selected = new Array(this.optionalMaxDepth).fill(null);
        },
        items(depth){
            return this.optionalProducts.reduce((items, optionalProduct) => {
                let optionalValues = optionalProduct.optionalValues.slice(); // clone array

                for(let index = 0; index < depth - 1; index++){
                    if(optionalValues[index] != this.selected[index]) return items;
                }
                if(!items.find(item => item.value == optionalValues[depth - 1])) {
                    if(optionalValues.length -1 === depth - 1){
                        items.push({ text: `${optionalValues[depth - 1]} ( + ${optionalProduct?.addPrice.format()} 원)`, value: optionalValues[depth - 1]});
                    } else {
                        items.push({ text: optionalValues[depth - 1], value: optionalValues[depth - 1]});
                    }
                }

                return items;
            }, [{ text: ":: 옵션선택 ::", value: null }]);
        },
        input(depth){
            for(var index = depth; index < this.optionalMaxDepth; index ++){
                this.$set(this.selected, index, null);
                this.$forceUpdate();
            }

            if(depth == this.optionalMaxDepth){
                let product = this.optionalProducts.find(optionalProduct => optionalProduct.optionalValues.toString() == this.selected.toString() );
                if(!product.stock){
                    alert('품절된 상품입니다.')
                    return;
                }

                if(!this.carts.some(cart => cart.product._id == product._id)){
                    this.carts.push({
                        product,
                        quantity: 1
                    });
                }
                this.$emit("edit", [{
                        product,
                        quantity: 1
                }])
            }
        }
    },

    computed: {
        optionalProducts(){ return this.product?.optionalProducts },
        optionalMaxDepth(){ return this.optionalProducts?.reduce((depth, optionalProduct) => depth < optionalProduct.optionalNames.length ? optionalProduct.optionalNames.length : depth , 0) },
        optionalNames(){ return this.optionalProducts[0].optionalNames || []; },
    },

    watch: {
        // value(){
        //     this.carts = this.value || [];
        //     this.init();
        // },
        optionalMaxDepth(){
            this.selected = new Array(this.optionalMaxDepth).fill(null);
        },
        carts: {
            deep: true,
            handler(){
                this.$emit("carts", this.carts);
            }
        }
    }
}
</script>

<style scoped>
</style>